import React from 'react'

import { Img } from './styles'

interface Props {
  img: string
  size?: 32 | 48 | 64 | 128
}

const Avatar: React.FC<Props> = ({ img, size = 32 }) => (
  <Img
    src={img}
    width={size}
    height={size}
  />
)

export default Avatar
